
import { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Dashboard from "./dashboard/Dashboard";
import Login from "./dashboard/Login";
import { AppointmentProvider } from "./context/AppointmentContext";
import Addpatient from "./dashboard/Addpatient";
import { ToastContainer } from "react-toastify";
import AppointmentStatusPage from "./dashboard/AppointmentStatusPage";
import { ConfigProvider } from 'antd';
import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';
import 'antd/dist/antd.css';
import Error404 from "./dashboard/NotFound";
import CancelStatuspage from "./dashboard/CancelStatuspage";
import AllStatus from "./dashboard/AllStatusPage";
import PaymentStatus from "./dashboard/PaymentStatus";



function App() {
  


useEffect(() => {
  const timer = setTimeout(() => {
    sessionStorage.clear();
    window.location.href = "/";
  }, 12 * 60 * 60 * 1000);

  return () => clearTimeout(timer);
}, []);
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#1890ff',
        },
      }}
    >
      <div>
        <ToastContainer />
        <AppointmentProvider>
          <Router>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/login" element={<Login />} />
              <Route path="/add-patient" element={<Addpatient />} />
              <Route path="/appointment-status" element={<AppointmentStatusPage />} />
              <Route path="/all-status" element={<AllStatus />} />
              <Route path="/cancel-status" element={<CancelStatuspage />} />
              <Route path="/payment-status" element={<PaymentStatus />} />
              <Route path="*" element={<Error404 />} />
            </Routes>
          </Router>
        </AppointmentProvider>
      </div>
    </ConfigProvider>
  );
}


export default App;
